import MachineDetails from "./MachineDetails";
import React, { useState, useEffect } from "react";
import { getShipToDetails } from "./api";
import { log } from "../Helper";
import MachineMilestone from "./MachineMilestone";
import { toast } from "react-toastify";
import LoaderComponent from "../LoaderComponent/LoaderComponent";
import { useUserInfo } from "../common/user-context";
import { SearchInput } from "../components/SearchInput";

const ControlTower = () => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [milestoneDetails, setMilestoneDetails] = useState([]);
  const [searchID, setSearchID] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [controlTowerPermissions, setControlTowerPermissions] = useState(null);

  const { userData } = useUserInfo();
  const authorities = userData.authorities;

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      if (
        authorities &&
        !authorities.includes("ROLE_FULL_APPLICATION_ACCESS")
      ) {
        const permissions = {
          controlTowerTabVisible: authorities.includes(
            "ROLE_CONTROL_TOWER_TAB_VISIBILITY"
          ),
          controlTowerAddressTabAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_ADDRESS_TAB_ACCESS"
          ),
          controlTowerUrgentActionAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_URGENT_ACTION_ACCESS"
          ),
          controlTowerShipHoldActionAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_SHIP_HOLD_ACTION_ACCESS"
          ),
          controlTowerLogsTabAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_LOGS_TAB_ACCESS"
          ),
          controlTowerEditAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_EDIT_ACCESS"
          ),
          controlTowerTransportationAndCostingTabAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_TRANSPORTATION_AND_COSTING_TAB_ACCESS"
          ),
          controlTowerDatesandStatusTabAccess: authorities.includes(
            "ROLE_CONTROL_TOWER_DATE_AND_STATUS_ACCESS"
          ),
        };
        // Set control tower permissions based on authorities
        setControlTowerPermissions(permissions);
        // console.log("Control Tower Permissions: ", permissions);
      } else if (
        authorities &&
        authorities.includes("ROLE_FULL_APPLICATION_ACCESS")
      ) {
        setIsUserAdmin(true);
        const permissions = {
          controlTowerTabVisible: true,
          controlTowerAddressTabAccess: true,
          controlTowerUrgentActionAccess: true,
          controlTowerShipHoldActionAccess: true,
          controlTowerLogsTabAccess: true,
          controlTowerEditAccess: true,
          controlTowerTransportationAndCostingTabAccess: true,
          controlTowerDatesandStatusTabAccess: true,
          controlTowerDocumentsTabAccess: true,
        };
        setControlTowerPermissions(permissions);
      }
    }
  }, [userData]);

  const handleSearch = (event) => {
    if (event.key === "Enter" && searchID.trim() && searchID.trim() !== "") {
      getShipToDetailsForMachine(searchID.trim());
      setIsShow(true);
    }
  };

  const handleChange = (event) => {
    setOrderDetails(null);
    setSearchID(event.target.value);
  };

  const getShipToDetailsForMachine = async (id) => {
    try {
      setIsLoading(true);
      const comar = id.length === 8 ? id.toUpperCase() : "";
      const serial =
        id.length === 17 || id.length === 13 ? id.toUpperCase() : "";
      if (id.length !== 8 && id.length !== 13 && id.length !== 17) {
        toast.error("Invalid comar or serial. Please adjust your entry.");
        setIsLoading(false);
      } else {
        const response = await getShipToDetails(comar, serial);
        log("resp", response);
        console.log("Response of COMAR: ", response);
        if (response?.httpResponse == 200) {
          setIsLoading(false);
          setIsShow(true);
          setOrderDetails(response.data);
          setMilestoneDetails(response.data.controlTowerDetailsList);
          toast.success(response.message);
        } else if (response?.httpResponse == 206) {
          setIsLoading(false);
          setIsShow(true);
          setOrderDetails(response.data);
          setMilestoneDetails(response.data.controlTowerDetailsList);
          toast.warn(response.message);
        } else {
          setIsLoading(false);
          setIsShow(false);
          toast.error(response?.message);
        }
      }
    } catch (error) {
      log("Error occured when fetching ship to adjustment details: ", error);
      setIsShow(false);
      setOrderDetails(null);
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        marginTop: 20,
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 20,
      }}
    >
      <div>
        <h3 className="pt-3 font-bold rounded-sm text-2xl">Control Tower</h3>
      </div>
      <div className="pt-4 pb-4 mt-3 px-3 py-1 bg-white rounded-xl border border-stone-300 flex flex-col gap-2 justify-start item-start">
        {/* <Typography className="font-200">{"Search"}</Typography> */}
        <SearchInput
          style={{ width: "20%" }}
          placeholder="Enter Comar or Serial"
          value={searchID}
          onChange={handleChange}
          onKeyDown={handleSearch}
          size="medium"
          sx={{
            fontSize: "2rem",
          }}
        />
      </div>
      {isLoading && <LoaderComponent />}
      {!isLoading && orderDetails && isShow && (
        <>
          <MachineDetails orderDetails={orderDetails} />
          <MachineMilestone
            getShipToDetailsForMachine={getShipToDetailsForMachine}
            orderUnit={orderDetails?.orderUnit}
            orderNumber={orderDetails?.orderNumber}
            orderYear={orderDetails?.orderYear}
            serial17={orderDetails?.serial17}
            milestoneDetails={milestoneDetails}
            countryDealersList={orderDetails.countryDealersList}
            isUserAdmin={isUserAdmin}
            controlTowerPermissions={controlTowerPermissions}
            userId={userData.userId}
            shipToDetails={orderDetails.shipToDetails}
            isLoading={isLoading} // Pass the isLoading and setIsLoading state so that child component can directly control the loading state
            setIsLoading={setIsLoading}
            locationList={orderDetails.locationList}
            logisticUnits={orderDetails.logisticUnits}
            providerId={orderDetails?.providerId}
          />
        </>
      )}
    </div>
  );
};

export default ControlTower;
